export default "__VITE_PUBLIC_ASSET__899210a1__"